import { PlusCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { paths } from '@app/constants';
import { Namespace, usePermissions } from '@data';
import { AntdTypography, Button } from '@ui/components';

const { Title } = AntdTypography;

export const Header = () => {
  const { t } = useTranslation([Namespace.ADMIN]);
  const navigate = useNavigate();
  const { IS_REVIEWER } = usePermissions();

  return (
    <header style={{ borderBottom: '1px solid #F0F0F0' }} className="p-4 flex items-center">
      <Title className="m-0 text-2xl font-medium" data-testid="questions-library-title">
        {t('questions_library.title')}
      </Title>
      {/* <Button
        type="primary"
        icon={<SettingOutlined />}
        className="bg-[#294BB2] shadow-none ml-auto mr-4"
      >
        {t('questions_library.merge_and_fix', { count: 342 })}
      </Button> */}
      {!IS_REVIEWER && (
        <Button
          role="link"
          type="primary"
          onClick={() => navigate(paths.questions_library.create)}
          icon={<PlusCircleOutlined />}
          className="shadow-none ml-auto rounded-[32px]"
          data-testid="add-question-button"
        >
          {t('questions_library.add_question')}
        </Button>
      )}
    </header>
  );
};
